module.exports = __webpack_public_path__ + "static/media/logo.f42a0f99.ico";